module.exports = __webpack_public_path__ + "img/Up.09320358.svg";